(function(window){
     var List = (function(){
       function List(params){
         this.items = [];
       }
       List.prototype = {
         add: function(item){
           this.items.push(item);
         },
         remove: function(item){
           var indexOf = this.items.indexOf(item);
           if(indexOf !== -1){
             this.items.splice(indexOf,1);
           }
         },
         find: function(callback, action){
           var callbackReturn,
               items = this.items,
               length = items.length,
               matches = [],
               i = 0;
           for(; i < length; i++){
             callbackReturn = callback(items[i], i);
             if(callbackReturn){
               matches.push(items[i]);
             }
           }
           if (action){
             action.call(this,matches);
           }
           return matches;
         }
       }
       return List;
     }());

     List.create = function(params){
       return new List(params);
     };

     window.List = List;

    }(window));


(function (window, google, list) {

     var Mapster = (function(){
       function Mapster(element, opts){
         this.gMap = new google.maps.Map(element, opts);
         this.markers = List.create();
         this.markerClusterer = new MarkerClusterer(this.gMap, []);
       }
       Mapster.prototype = {
         _on: function(opts){
           var self = this;
           google.maps.event.addListener(opts.obj, opts.event, function(e){
             opts.callback.call(self, e);
           });
         },
         addMarker: function(opts){
           var marker;
           opts.position = {
             lat: opts.lat,
             lng: opts.lng
           }
           marker = this._createMarker(opts);
           this.markerClusterer.addMarker(marker);
           this.markers.add(marker);
           if (opts.event){
             this._on({
               obj: marker,
               event: opts.event.name,
               callback: opts.event.callback
             });
           }
           if (opts.content){
             this._on({
               obj: marker,
               event: 'click',
               callback: function(){
                                if (window.infowindow) window.infowindow.close();
                 var infoWindow = new google.maps.InfoWindow({
                   content: opts.content
                 });
                               window.infowindow = infoWindow;
                 infoWindow.open(this.gMap, marker);
               }
             });
           }
           return marker;
         },
         findBy: function(callback){
           return this.markers.find(callback);
         },
         removeBy: function(callback){
           var self = this;
           self.markers.find(callback, function(markers){
             markers.forEach(function(marker){
               if (self.markerClusterer) {
                 self.markerClusterer().removeMarker(marker);
               } else {
                 marker.setMap(null);
               }
             });
           });
         },
         _createMarker: function(opts){
           opts.map = this.gMap;
           return new google.maps.Marker(opts);
         }
       }

       return Mapster;
     }());

     Mapster.create = function(element, opts){
       return new Mapster(element, opts);
     }
        
      window.Mapster = Mapster;

    }(window, google));

(function($){
    (function(window, mapster){
      // map options
      var options = {
        center: {
          lat: 12.216545,
          lng: 122.18
        },
        zoom: 5
      }
      var element = document.getElementById('amlocator-map-canvas');

      // map init
      map = Mapster.create(element, options);
      
//       var newMap = new google.maps.Map($('#amlocator-map-canvas'), {zoom: 4,
//           center: {lat: 37.090, lng: -95.712},
//           mapTypeId: 'terrain'})

      // adding markers
      for (var i = storeArray.length - 1; i >= 0; i--) {
        var store = storeArray[i];
        var marker = map.addMarker({
          lat: store.lat,
          lng: store.lng,
          id: i, 
          content: store.infoContent
        });
      }
      

      /* Modified by: MJ */
      const input = document.getElementById('amlocator-search');

      var addresses = storeArray.map(store => {
          var address = $(store.infoContent).find('[data-tag="address"]')
          return address.text();
      })

      $(input).autocomplete({
        source: addresses,
        select: (event, ui) => {
          var value = ui.item.value || null;

          if(value) {
            var selected_store = storeArray.find(store => {
              var address = $(store.infoContent).find('[data-tag="address"]').text().toLowerCase();

              return address === value.toLowerCase();
            }) || null;
            if(selected_store) {
              var mrkr = map.markers.items.find(marker => marker.lat === selected_store.lat && marker.lng === selected_store.lng)
              loadLocation({
                lat: selected_store.lat,
                lng: selected_store.lng,
                zoom: 18.5,
                marker: mrkr
              })
              if(window.innerWidth <= 940) {
                const y = element.getBoundingClientRect().top + window.scrollY;
                window.scroll({
                  top: y,
                  behavior: 'smooth'
                });
              }
            }
          }
        }
      })
      /* Modified by: MJ */
      
      // input.addEventListener('input', (e) => {
      //   var $this = e.target;
      //   var stores = window.storeArray || [];

      //   var search_stores = stores.filter(store => {
      //     var element = $(store.infoContent),
      //         address = element.find('[data-tag="address"]').text().toLowerCase()
              
      //     return address.includes($this.value.toLowerCase())
      //   })

      //   console.log(search_stores)
      // })
      // const autocomplemte_options = {
      //   componentRestrictions: { country: "ph" },
      //   fields: ['place_id', 'geometry', 'name']
      // };
      // const autocomplete = new google.maps.places.Autocomplete(input, autocomplemte_options);
      // console.log(autocomplete)
      // autocomplete.addListener('places_changed', onPlaceChanged)

      // function onPlaceChanged() {
      //   console.log("Testing search")
      //   var place = autocomplete.getPlaces();

      //   console.log(place)
      //   if(place.geometry) {
      //     loadLocation({
      //       lat: place.geometry.location.lat(),
      //       lng: place.geometry.location.lng(),
      //       zoom: 14
      //     })
      //   }
      // }
      // var searchBox = new google.maps.places.SearchBox(document.getElementById('amlocator-search'));
      // place change event on search box
      // google.maps.event.addListener(autocomplete, 'places_changed', function(){
        
      //   var places = autocomplete.getPlaces();
      //     console.log(places)
      //   //bound
      //   var bounds = new google.maps.LatLngBounds();
      //   var i, place;

      //   for(i=0; place=places[i];i++){
      //     console.log(places[i])
      //     console.log('lat: ' + place.geometry.location.lat());
      //     console.log('lng: ' +place.geometry.location.lng());
      //    bounds.extend(place.geometry.location);
      //   }

        
      //   if(window.innerWidth <= 940) {
      //     element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
      //   }

      //   map.gMap.fitBounds(bounds);
      //   map.gMap.setZoom(14);

      // });


      //location list map redirect on click
//       $('#leftbar-storecols .location-block').click(function(){
//         var $this = $(this),
//             locLat = $this.data('lat'),
//             locLng = $this.data('lng'),
//             locId = $this.data('amid'),
//             mrkrs = map.markers.items,
//             mrkr;

//             map.gMap.setCenter({lat: locLat, lng: locLng});
//             map.gMap.setZoom(18.5);

//             for(var i = 0; i < mrkrs.length; i++){
//               if(mrkrs[i].id == locId){
//                 mrkr = mrkrs[i];
//               }
//             }
//             google.maps.event.trigger(mrkr, 'click');            
//             // alert(locLat + " " + locLng)
//       })

      function loadLocation(option) {
        if(!option) return;
        
        map.gMap.setCenter({lat: option.lat, lng: option.lng});
        map.gMap.setZoom(option.zoom);

        if(option.marker) {
          google.maps.event.trigger(option.marker, 'click');
        }else {
          new google.maps.Marker({
            position: {lat: option.lat, lng: option.lng},
            map: map
          })
        }
      }
      
      //location list map redirect v2
      $('.location-body').click(function(){
        var $this = $(this),
            locLat = $this.parent().data('lat'),
            locLng = $this.parent().data('lng'),
            locId = $this.parent().data('amid'),
            mrkrs = map.markers.items,
            mrkr;

            for(var i = 0; i < mrkrs.length; i++){
              if(mrkrs[i].id == locId){
                mrkr = mrkrs[i];
              }
            }
            loadLocation({
              lat: locLat,
              lng: locLng,
              zoom: 18.5,
              marker: mrkr
            })
            if(window.innerWidth <= 940) {
              element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
            }    
      })

      /* Modified by: MJ */
      //search nearest mall from current position
      document.getElementById('locateNearBy').addEventListener('click', function(){
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position){ 
            var currentLat = position.coords.latitude, 
                currentLng = position.coords.longitude,
                currentPosition = {lat: currentLat, lng: currentLng};
            var distances = [];

            storeArray.forEach(store => {
              var store_position = {lat: store.lat, lng: store.lng},
                  d = getDistance(currentPosition, store_position);

              distances.push({...store, distance: d})
            })

            // for (var i = storeArray.length - 1; i >= 0; i--) {
            //     var store = storeArray[i],
            //         filterLatLng = new google.maps.LatLng(store.lat, store.lng),
            //         d = google.maps.geometry.spherical.computeDistanceBetween(currentPosition, filterLatLng);
            //     // alert(filterLatLng);
            //     distances[i] = d;
            //     if (closest == -1 || d < distances[closest]) {
            //         closest = i;
            //         var boundsDistance = filterLatLng;
            //     }
            // }
            // alert(closest)
            var closest_distance = Math.min(...distances.map(store => store.distance))
            var storeVar = distances.find(store => store.distance === closest_distance),
                storeLatLng = {lat:storeVar.lat, lng:storeVar.lng},
                storeBounds = new google.maps.LatLngBounds(storeLatLng)

            map.gMap.setCenter(currentPosition)
            map.gMap.fitBounds(storeBounds);
            map.gMap.panToBounds(storeBounds);
            map.gMap.setZoom(map.gMap.getZoom()+1);
            if(window.innerWidth <= 940) {
              element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
            }             
          }) } else { 
              alert("Geolocation is currently not working.");
            }
      })


      /* Modified by: MJ */

      var rad = function(x) {
        return x * Math.PI / 180;
      };
      
      var getDistance = function(p1, p2) {
        var R = 6378137; // Earth’s mean radius in meter
        var dLat = rad(p2.lat - p1.lat);
        var dLong = rad(p2.lng - p1.lng);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
          Math.sin(dLong / 2) * Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d; // returns the distance in meter
      };
      //search on click event
      document.getElementById('sortByFilter').addEventListener('click', function() {
        var $kmValue = $("#amlocator-radius"),
            pi = 3.1415926535897932384626433832795,
            // $kmToMiles = $kmValue.val()*0.62137, - conversion to Miles
            $meters = $kmValue.val()*1000, //-convertion to Meters
            $storesList = $('#leftbar-storecols .location-block');

        var nearby_stores = []

        if($kmValue.val() === null) {
          alert('Please select a radius!')
          return;
        }

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position){
              var currentLat = position.coords.latitude, 
                  currentLng = position.coords.longitude;
              
              var currentPosition = {lat: currentLat, lng: currentLng};

              /* Get all stores distance */
              storeArray.forEach(store => {
                var filterLatLng = {lat:store.lat, lng:store.lng},
                    distance = getDistance(currentPosition, filterLatLng);
                if($kmValue.val() == "") {
                  nearby_stores.push({...store, distance})
                }else if(distance <= $meters) {
                  nearby_stores.push({...store, distance})
                }
              })
              /* Get all stores distance */

              if(nearby_stores.length > 0){
                  // var places = searchBox.getPlaces();
                  // var myRadius = $meters,
                  var myRadius = Math.max(...nearby_stores.map(store => store.distance)),
                      //Math.sqrt($meters * pi)*20, - just another wrong formula *wink
                      // Math.sqrt($kmToMiles / pi)*1000 - Tested Formula for safekeeping
                      // currLatLng = new google.maps.LatLng(places[0].geometry.location.lat(), places[0].geometry.location.lng()),
                      currLatLng = currentPosition,
                    circ = new google.maps.Circle({
                        center: currLatLng,
                        fillOpacity: 0,
                        strokeOpacity:0,
                        map: map.gMap,
                        radius: myRadius
                      });
                  var counter = 0;
                
                 //set radius to chosen KM value
                  circ.setRadius(myRadius);
                  map.gMap.fitBounds(circ.getBounds());
                  map.gMap.panToBounds(circ.getBounds());
                  map.gMap.setZoom(map.gMap.getZoom());
                
                if(window.innerWidth <= 940) {
                  element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
                }  
      
                  //filters the store location list
                  $storesList.each((i, store) => {
                    var store_row = $(store),
                        lat = store_row.data('lat'),
                        lng = store_row.data('lng');

                    //Check if belong to nearby radius
                    var is_belong = nearby_stores.find(n_store => n_store.lat === lat && n_store.lng === lng) || null;
                    //Toggle hide.
                    if(is_belong) {
                      store_row.show()
                    } else {
                      store_row.hide();
                    }
                    
                  })
                  // for (var i = storeArray.length - 1; i >= 0; i--) {
                  //   var store = storeArray[i];
                  //   var filterLatLng = new google.maps.LatLng(store.lat, store.lng);
                  //   var distanceRaw = google.maps.geometry.spherical.computeDistanceBetween(currLatLng, filterLatLng),
                  //       distanceComputed = distanceRaw / 1000;
      
                  //   if(distanceComputed > $kmValue.val()){
                  //     $storesList.find('div[data-lat="'+ store.lat +'"][data-lng="'+ store.lng +'"]').hide()
                  //   }
                  //   else if(distanceComputed <= $kmValue.val()){
                  //     $storesList.find('div[data-lat="'+ store.lat +'"][data-lng="'+ store.lng +'"]').show()
                  //   }
      
                  // }            
              }
              else{
                alert(`No stores located within ${$kmValue.val()}KM Radius!`)         
              }
            })
        }


   
      })
      
    }(window, window.Mapster));  
  $('.today_schedule').click(function() {
    $(this).parent().find('.all_schedule').slideToggle();
    $(this).parent().find('.locator_arrow').toggleClass('dropped');
  })
})(jQuery)